import { Address } from "@/models/address/address";
import { OrderStatus, OrderType } from "@/models/order/helpers";
import { LineItem } from "@/models/order/order";
import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import { OrderState } from "./types";

export const defaultState: OrderState = {
  _id: null,
  status: OrderStatus.Open,
  type: OrderType.Quote,
  status_log: [],
  customer_id: "",
  customer_name: "",
  customer_netsuite_id: undefined,
  customer_netsuite_contact_id: undefined,
  customer_netsuite_payment_terms_id: undefined,
  customer_netsuite_price_level_id: undefined,
  customer_netsuite_price_level_discount: undefined,
  notes: "",
  contact_details: {
    quote_name: "",
    company_name: "",
    first_name: "",
    last_name: "",
    phone: "",
    email: ""
  },
  shipping_details: {
    label: "",
    addressee: "",
    attention: "",
    address: {} as Address,
    phone: "",
    email: ""
  },
  billing_details: {
    addressee: "",
    attention: "",
    address: {} as Address,
    phone: "",
    email: ""
  },
  payment_details: {
    method: undefined
  },
  items: [] as LineItem[]
};

const state = { ...defaultState };

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
